import { AlertCircle, AlertTriangle, Info, ShieldAlert } from 'lucide-react'

import { StatusMessage } from '@krp/ui-kit'

import type { ReportVm } from '../model/types'
import { QueryState } from '../../pricing/ui/QueryState'
import '../../pricing/ui/onec-ui.css'

const SEVERITY_ICONS = {
  Error: <AlertCircle size={14} aria-hidden="true" />,
  Warning: <AlertTriangle size={14} aria-hidden="true" />,
  Info: <Info size={14} aria-hidden="true" />,
} as const

/**
 * Отчёт проверки накладной. Замечания — текст сервера дословно; тяжесть
 * читается значком и словом, блокировка — отдельной заметной строкой.
 */
export function ReportView({ report, emptyText, onRetry }: { report: ReportVm; emptyText: string; onRetry?: () => void }) {
  if (report.query.status !== 'ready') return <QueryState query={report.query} emptyText={emptyText} {...(onRetry ? { onRetry } : {})} />
  return (
    <div className="onec-screen">
      {report.isBlocked ? (
        <StatusMessage
          kind="error"
          title="Накладную нельзя использовать: есть ошибки"
          text="Исправьте разметку или файл и проверьте заново."
        />
      ) : (
        <p role="status">
          <ShieldAlert size={14} aria-hidden="true" /> Блокирующих ошибок нет
        </p>
      )}
      <ul className="onec-muted">
        {report.summary.map((line) => (
          <li key={line}>{line}</li>
        ))}
        {report.totalsText !== null && <li>Сумма: {report.totalsText}</li>}
        {report.validatedAtText !== null && <li>Проверено: {report.validatedAtText}</li>}
      </ul>
      {report.truncated && <p className="onec-problem">Лист усечён: проверена только часть накладной</p>}
      {report.issues.length === 0 ? (
        <p className="onec-muted">Замечаний нет</p>
      ) : (
        <div className="onec-scroll">
          <table className="onec-table">
            <caption className="onec-muted">Замечаний: {report.issues.length}</caption>
            <thead>
              <tr>
                <th>Тяжесть</th>
                <th>Где</th>
                <th>Замечание</th>
              </tr>
            </thead>
            <tbody>
              {report.issues.map((issue) => (
                <tr key={issue.key} data-severity={issue.severity}>
                  <td>
                    {SEVERITY_ICONS[issue.severity]} {issue.severityLabel}
                  </td>
                  <td>{issue.where === '' ? '—' : issue.where}</td>
                  <td>
                    {issue.message} <span className="onec-muted onec-code">{issue.code}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
